<template>
	<div>
		<div class="qualified">
			<div class="director-title">
				<div>{{ breadcrumbList[1] }}抽样报告</div>
				<div v-if="breadcrumbList[2] != 'all'">
					时间:
					<span>{{ breadcrumbList[0] }}</span>
				</div>
			</div>
			<div class="doctorPage doctorSeach" v-if="breadcrumbList[2] == 'all'">
				<div class="selectSearch">
					<el-form ref="form" :model="directorParameter" class="qcFrom" :inline="true">
						<el-form-item label="报告编号">
							<el-input v-model="directorParameter.AccNo" class="name" placeholder="请输入报告编号" size="mini"></el-input>
						</el-form-item>
						<el-form-item label="质控时间">
							<el-date-picker
								class="time sliderDataCls"
								v-model="directorParameter.data"
								type="monthrange"
								@change="datePicker"
								:picker-options="pickerOptions"
								unlink-panels
								range-separator="~"
								value-format="yyyy/MM"
								format="yyyy-MM"
								start-placeholder="开始时间"
								end-placeholder="结束时间"
							></el-date-picker>
						</el-form-item>
						<el-form-item>
							<el-button type="primary" @click="search()" round>查询</el-button>
						</el-form-item>
					</el-form>
				</div>
			</div>
			<el-row :gutter="30" v-loading="loading">
				<el-col :span="tootipType ? 12 : 24">
					<el-table class="qcTable doctor" ref="multipleTable" :data="QualifiedList" highlight-current-row>
						<el-table-column prop="AccNo" min-width="150" label="报告编号" column-key="HospitalGuid">
						</el-table-column>
						<el-table-column prop="ChekingItems" label="检查项目" :show-overflow-tooltip="true">
						</el-table-column>
						<el-table-column prop="Score" label="得分"></el-table-column>
						<el-table-column prop="QCDt" min-width="150" label="质控时间"></el-table-column>
						<el-table-column prop="" label="操作" fixed="right" width="180">
							<template slot-scope="scope">
								<span class="tableOpe" v-if="scope.row.ExpertUserGuids.length <= 1"
									@click="handleClick(scope.row, 'length')">查看结果</span>
								<span class="tableOpe" v-else
									@click="handleCurrentChange(scope.row, scope.$index, $event)">查看结果</span>
							</template>
						</el-table-column>
					</el-table>
				</el-col>
				<el-col v-show="tootipType" :span="12" class="exporttootip" :style="{ minHeight: height + 'px' }">
					<i ref="toopIcon" class="tootipCaretLeft el-icon-caret-left"></i>
					<div class="title">
						此报告有 {{ qcresultsByTaskList.length }} 位专家参与质控
						<i class="el-icon-close" @click="closeRbox"></i>
					</div>
					<ul class="qcresultsBox" :style="{ height: height + 'px', minHeight: '85px' }">
						<li v-for="item in qcresultsByTaskList" :key="item.Name" class="qcresults">
							<el-row>
								<el-col :span="6">专家 : {{ item.Name }}</el-col>
								<el-col :span="6">报告评分 : {{ item.ReportScore }}</el-col>
								<el-col :span="6">影像评分 : {{ item.ImageScore }}</el-col>
								<el-col :span="6">{{ item.StatusName }}</el-col>
							</el-row>
							<el-row>
								<el-col :span="18">完成时间 : {{ item.QCDt }}</el-col>
								<el-col :span="6" class="tableOpe"><span @click="handleClick(item)">查看详情</span></el-col>
							</el-row>
						</li>
					</ul>
				</el-col>
			</el-row>
			<div class="pages">
				<el-pagination class="pageAll" layout="prev, pager, next" :total="QualifiedPart.total"
					:page-size="QualifiedPart.PageCount" :current-page="QualifiedPart.PageIndex"
					@current-change="currentChange"></el-pagination>
			</div>
		</div>
	</div>
</template>

<script>
import { mapState, mapActions, mapMutations } from 'vuex';
export default {
	data() {
		return {
			currentRow: null,
			height: 0,
			datas: {},
			pageshow: true,
			directorParameter:{
				AccNo:'',
				data:[]
			},
			pickerOptions: {
				shortcuts: [
					{
						text: '本月',
						onClick(picker) {
							picker.$emit('pick', [new Date(), new Date()]);
						}
					},
					{
						text: '今年至今',
						onClick(picker) {
							const end = new Date();
							const start = new Date(new Date().getFullYear(), 0);
							picker.$emit('pick', [start, end]);
						}
					},
					{
						text: '最近六个月',
						onClick(picker) {
							const end = new Date();
							const start = new Date();
							start.setMonth(start.getMonth() - 6);
							picker.$emit('pick', [start, end]);
						}
					}
				],
				onPick: obj => {
					this.pickerMinDate = new Date(obj.minDate).getTime();
				},
				disabledDate: time => {
					if (this.pickerMinDate) {
						const day1 = 365 * 24 * 3600 * 1000;
						let maxTime = this.pickerMinDate + day1;
						let minTime = this.pickerMinDate - day1;
						return time.getTime() > maxTime || time.getTime() < minTime || time.getTime() > Date.now() - 1 * 24 * 3600 * 1000;
					} else {
						return time.getTime() > Date.now() - 1 * 24 * 3600 * 1000;
					}
				}
			}
		};
	},
	computed: {
		...Vuex.mapState('breadcrumb', ['tootipType', 'selectRow']),
		...Vuex.mapState('supervisor', ['regionType','setDate', 'loading', 'QualifiedList', 'QualifiedPart', 'breadcrumbList', 'GetReportListArr', 'HospitalAVGScoreArr']),
		...Vuex.mapState('managerPlanList', ['qcresultsList', 'qcresultsByTaskList']),
		...Vuex.mapState('visualization', ['visbreadcrumbList']),
		lists() {
			return this.QualifiedList;
		}
	},
	watch: {
		lists(old) {
			let _this = this;
			if (this.selectRow.row != 1) {
				this.currentChangesSecond(this.selectRow.pageIndex);
				this.QualifiedPart.PageIndex = this.selectRow.pageIndex;
				this.pageshow = false;
				this.$nextTick(() => {
					_this.pageshow = true;
					_this.$refs.multipleTable.setCurrentRow(_this.QualifiedList[_this.selectRow.index]);
				});
				if (_this.QualifiedList) {
					this.GetQCResultsByTask({
						samplingtaskguid: _this.QualifiedList[_this.selectRow.index].SamplingTaskGuid,
						reportGuid: _this.QualifiedList[_this.selectRow.index].ReportGuid
					});
				}
			} else {
				this.$refs.multipleTable.setCurrentRow();
			}
		}
	},
	activated() {
		this.initpar();
	},
	methods: {
		...Vuex.mapMutations('breadcrumb', ['setqcresultsShow', 'setTootipType']),
		...Vuex.mapMutations('supervisor', ['currentChangesSecond', 'setSplitScreen','setSetDate']),
		...Vuex.mapMutations('doctor', ['setisSubmintflag','setIsSubmint', 'setDetalLoading', 'setReportGuid', 'setDetailsParameter']),
		...Vuex.mapActions('doctor', ['GetReporterReportList', 'GetReportDetail']),
		...Vuex.mapActions('supervisor', ['GetReportList']),
		...Vuex.mapActions('managerPlanList', ['GetQCResultsByTask']),
		search(){
			let isUnqualified = true;
			isUnqualified = this.QualifiedPart.type == 'qualified'?false:true;
			this.GetReportList({
				hospitalGuid: this.QualifiedPart.hospitalGuid,
				isUnqualified: isUnqualified,
				type:this.HospitalAVGScoreArr.type,
				AccNo:this.directorParameter.AccNo
				});	
		},
		datePicker(event){
			// this.directorParameter.date = event
			this.setDate.startdt = event[0];
			this.setDate.enddt = event[1];
			// this.setSetDate(this.directorParameter)
		},
		initpar() {
			this.QualifiedPart.scoreType = this.breadcrumbList[2] == 'scoreType'?this.QualifiedPart.scoreType:0;
			let isUnqualified = true;
			
			// let breadHandler = {
			// 	'pie':()=>{
			// 		this.setDateFun(),
			// 		this.currentChangesSecond(1),
			// 		this.getPieList(),
			// 	},
			// 	'line':()=>{
					
			// 	}
			// }
			if (this.breadcrumbList[2] == 'pie') {
				this.setDateFun();
				this.currentChangesSecond(1);
				this.getPieList();
			} else if (this.breadcrumbList[2] == 'line') {
				this.setDateFun();
				this.HospitalAVGScoreArr.regionId = '';
				this.HospitalAVGScoreArr.type = this.GetReportListArr.tabType;
				switch (this.GetReportListArr.status) {
					case 'imgcenter':
						this.GetReportList({
							hospitalGuid: this.GetReportListArr.hospitalGuid,
							doctorName: '',
							regionId: '',
							isUnqualified: this.GetReportListArr.unqualified
						});
						break;
					case 'personal':
						this.GetReportList({
							hospitalGuid: this.GetReportListArr.hospitalGuid,
							doctorName: this.GetReportListArr.DoctorName,
							regionId: '',
							isUnqualified: this.GetReportListArr.unqualified
						});
						break;
					case 'region':
						this.HospitalAVGScoreArr.regionId = this.GetReportListArr.regionId;
						this.GetReportList({
							hospitalGuid: '',
							doctorName: '',
							isUnqualified: this.GetReportListArr.unqualified
						});
						break;
					default:
						this.GetReportList({
							hospitalGuid: this.QualifiedPart.HospitalGuid,
							isUnqualified: this.GetReportListArr.unqualified
						});
				}
			} else if (this.breadcrumbList[2] == 'doubleLine') {
				this.setDateFun();
				this.HospitalAVGScoreArr.type = this.GetReportListArr.tabType;
				this.GetReportList({
					hospitalGuid: this.QualifiedPart.HospitalGuid,
					isUnqualified: true,
					doctorName: ''
				});
			} else if (this.breadcrumbList[2] == 'doubleLineregionFfalse') {
				this.setDateFun();
				this.HospitalAVGScoreArr.type = this.GetReportListArr.tabType;
				this.HospitalAVGScoreArr.regionId = '';
				this.GetReportList({
					hospitalGuid: this.QualifiedPart.HospitalGuid,
					isUnqualified: true,
					doctorName: ''
				});
			} else if (this.breadcrumbList[2] == 'task') {
				this.setDateFun();
				this.HospitalAVGScoreArr.type = this.GetReportListArr.tabType;
				this.GetReportList({
					hospitalGuid: this.GetReportListArr.hospitalGuid,
					doctorName: this.breadcrumbList[1],
					samplingTaskGuid: this.GetReportListArr.samplingTaskGuid
				});
			}else if (this.breadcrumbList[2] == 'doctor') {
				this.setDateFun();
				isUnqualified = this.QualifiedPart.type == 'qualified'?false:true;
				this.GetReportList({
					hospitalGuid: this.QualifiedPart.hospitalGuid,
					doctorName: this.breadcrumbList[1],
					isUnqualified: isUnqualified,
					type:this.HospitalAVGScoreArr.type
				});	
			}else if (this.breadcrumbList[2] == 'all') {
				this.setDateFun();
				isUnqualified = this.QualifiedPart.type == 'qualified'?false:true;
				this.directorParameter.data = [this.setDate.startdt,this.setDate.enddt]
				this.GetReportList({
					hospitalGuid: this.QualifiedPart.hospitalGuid,
					isUnqualified: isUnqualified,
					type:this.HospitalAVGScoreArr.type,
					samplingTaskGuid:this.directorParameter.samplingTaskGuid
				});	
			}else if(this.breadcrumbList[2] == 'scoreType'){
				this.setDateFun();
				let scoreType = 0;
				isUnqualified = this.QualifiedPart.type == 'qualified'?false:true;
				scoreType = this.QualifiedPart.scoreType != 0?this.QualifiedPart.scoreType:0;
				this.GetReportList({
					hospitalGuid: this.QualifiedPart.hospitalGuid,
					doctorName: this.breadcrumbList[1],
					isUnqualified: isUnqualified,
					type:this.HospitalAVGScoreArr.type,
					scoreType:scoreType
				});	
			}else if(this.breadcrumbList[2] == 'times'){
				this.setDateFun();
				isUnqualified = this.QualifiedPart.type == 'qualified'?false:true;
				this.GetReportList({
					hospitalGuid: this.QualifiedPart.hospitalGuid,
					doctorName: this.breadcrumbList[1],
					isUnqualified: isUnqualified,
					type:this.HospitalAVGScoreArr.type,
				});	
			}else if(this.breadcrumbList[2] == 'itemDesc'){
				this.setDateFun();
				let itemDesc = '';
				isUnqualified = this.QualifiedPart.type == 'qualified'?false:true;
				itemDesc = this.QualifiedPart.itemDesc != ''?this.QualifiedPart.itemDesc:'';
				this.GetReportList({
					hospitalGuid: this.QualifiedPart.hospitalGuid,
					isUnqualified: isUnqualified,
					itemDesc:itemDesc,
					isSerious:this.QualifiedPart.descType == 1?false:true
				});
			} else {
				if (this.QualifiedPart.type == 'qualified') {
					this.HospitalAVGScoreArr.type = this.GetReportListArr.tabType;
					this.GetReportList({
						hospitalGuid: this.QualifiedPart.hospitalGuid,
						doctorName: this.breadcrumbList[1],
						isUnqualified: false
					});
				}else{
					this.GetReportList({
						hospitalGuid: this.QualifiedPart.hospitalGuid,
						doctorName: '',
						isUnqualified: true
					});
				}
			}
		},
		setDateFun(){
			this.setDate.startdt = this.breadcrumbList[0].split('-')[0];
			this.setDate.enddt = this.breadcrumbList[0].split('-')[1];
		},
		closeRbox() {
			this.setTootipType(false);
			this.$refs.multipleTable.setCurrentRow();
		},
		// 右侧出现专家列表
		handleCurrentChange(val, index, e) {
			this.selectRow.index = index;
			this.selectRow.row = val;
			this.currentRow = val;
			let target = e.target || e.originalTarget || e.toElement ||e.path[0];
			if (target.tagName == 'SPAN' || target.nodeName == 'SPAN') {
				this.setTootipType(true);
				this.datas.ReportGuid = val.ReportGuid;
				this.datas.SamplingTaskGuid = val.SamplingTaskGuid;
				this.GetQCResultsByTask({
					samplingtaskguid: val.SamplingTaskGuid,
					reportGuid: val.ReportGuid
				});
				let difference = e.currentTarget.parentElement.parentElement.offsetHeight / 2;
				this.$refs.toopIcon.style.top = e.currentTarget.parentElement.parentElement.offsetTop + difference + 25 + 'px';
				let ele = document.getElementsByClassName('qcTable')[0];
				if (ele) {
					this.height = document.getElementsByClassName('qcTable')[0].offsetHeight - 60;
				}
			}
		},

		// 跳转至详情页
		handleClick(val) {
			let arg = arguments[1];
			this.qcresultsList.Name = val.Name;
			this.setqcresultsShow(!arg);
			if (arg) {
				// this.setqcresultsShow(false);
				// if (arg == 'table') {
				// 	this.qcresultsList.ExpertUserGuid = '';
				// } else {
				// 	this.qcresultsList.ExpertUserGuid = val.ExpertUserGuids[0];
				// }
				this.qcresultsList.ExpertUserGuid = arg == 'table'?'':val.ExpertUserGuids[0];
				this.qcresultsList.ReportGuid = val.ReportGuid;
				this.qcresultsList.SamplingTaskGuid = val.SamplingTaskGuid;
			} else {
				this.qcresultsList.ExpertUserGuid = val.ExpertUserId;
				this.qcresultsList.ReportGuid = this.datas.ReportGuid;
				this.qcresultsList.SamplingTaskGuid = this.datas.SamplingTaskGuid;
			}
			//详情不可编辑
			this.setIsSubmint(true);
			this.setDetalLoading(true);
			this.setDetailsParameter({
				reportGuid: this.qcresultsList.ReportGuid,
				samplingTaskGuid: this.qcresultsList.SamplingTaskGuid,
				ExpertUserGuid: this.qcresultsList.ExpertUserGuid
			});
			this.GetQCResultsByTask({
				samplingtaskguid: this.qcresultsList.SamplingTaskGuid,
				reportGuid: this.qcresultsList.ReportGuid
			});
			// this.setqcresultsShow(true);
			// this.GetReportDetail();
			this.$router.push('/home/doctor/scoring');
		},
		formattertime(row, column, cellValue) {
			if (cellValue != '' && cellValue != null) {
				return cellValue.substring(0, cellValue.length - 3);
			} else {
				return cellValue;
			}
		},
		//隔行换色
		tableRowClassName({ row, rowIndex }) {
			return 'hangInTheAir';
		},
		getPieList() {
			let keyNameArr = {};
			let regionId = this.HospitalAVGScoreArr.regionId;
			this.HospitalAVGScoreArr.regionId = '';
			this.HospitalAVGScoreArr.type = this.GetReportListArr.tabType;
			switch (this.GetReportListArr.status) {
				case 'imgcenter':
					keyNameArr.hospitalGuid = this.GetReportListArr.hospitalGuid;
					keyNameArr.DoctorName = '';
					break;
				case 'personal':
					keyNameArr.hospitalGuid = this.GetReportListArr.hospitalGuid;
					keyNameArr.doctorName = this.GetReportListArr.DoctorName;
					break;
				case 'region':
					keyNameArr.hospitalGuid = '';
					keyNameArr.doctorName = '';
					this.HospitalAVGScoreArr.regionId = this.GetReportListArr.regionId;
					break;
				case 'supervisor':
					this.HospitalAVGScoreArr.regionId = regionId;
				break;
				default:
					keyNameArr.doctorName = '';
					keyNameArr.hospitalGuid = '';
			}
			keyNameArr.isUnqualified = true;
			keyNameArr.modalityType = undefined;
			keyNameArr.scanType = undefined;
			keyNameArr.bodypart = undefined;
			
			let arrType = {
				'设备类型': ()=>{keyNameArr.modalityType = this.GetReportListArr.name},
				'扫描方式': ()=>{keyNameArr.scanType = this.GetReportListArr.name},
				'检查部位': ()=>{keyNameArr.bodypart = this.GetReportListArr.name},
			}
			let reportListArr = this.GetReportListArr.type;
			arrType[reportListArr]() || {}
			keyNameArr.isUnqualified = Object.keys(arrType).indexOf(reportListArr)>-1?false:true;
			
			// if (this.GetReportListArr.type == '设备类型') {
			// 	keyNameArr.isUnqualified = false;
			// 	keyNameArr.modalityType = this.GetReportListArr.name;
			// } else if (this.GetReportListArr.type == '扫描方式') {
			// 	keyNameArr.isUnqualified = false;
			// 	keyNameArr.scanType = this.GetReportListArr.name;
			// } else if (this.GetReportListArr.type == '检查部位') {
			// 	keyNameArr.isUnqualified = false;
			// 	keyNameArr.bodypart = this.GetReportListArr.name;
			// }
			if (this.regionType.type == 5) {
				keyNameArr.hospitalGuid = this.regionType.HospitalGuid;
			}
			this.GetReportList(keyNameArr);
		},
		currentChange(val) {
			this.selectRow.pageIndex = val;
			this.setTootipType(false);
			this.currentChangesSecond(val);
			this.breadcrumbList[2] == 'pie'?this.getPieList():this.initpar();
			// if (this.breadcrumbList[2] == 'pie') {
			// 	this.getPieList();
			// } else {
			// 	this.initpar();
			// }
			document.body.scrollTop = document.documentElement.scrollTop = 0;
		}
	}
};
</script>
<style lang="scss" scope>
	.director-title{
		padding-bottom: 20px !important;
		border-bottom: 1px solid #3d4049;
		margin-bottom: 0;
	}
	.el-date-editor .el-range-separator{
		line-height: 21px;
	}
	.sliderDataCls .el-icon-date{
		right: 2px;
    	top: -3px;
	}
</style>